export const DefaultTheme = {
    colors: {
        common: {
            white: '#ffffff',
            black: '#000000'
        },
        primary: {
            main: '#1b75eb',
            light: '#63a2f4',
            dark: '#0148a5',
            contrastText: '#ffffff'
        },
        secondary: {
            main: '#10fab8',
            light: '#a6fce4',
            dark: '#02dd9f',
            contrastText: '#000'
        },
        success: {
            main: '#00b0a6',
            light: '#e6f7f6',
            dark: '#00716a',
            contrastText: '#ffffff'
        },
        error: {
            main: '#ff5962',
            light: '#feeeef',
            dark: '#c3373f',
            contrastText: '#ffffff'
        },
        grey: ['#808080', '#999999', '#B3B3B3', '#CCCCCC', '#E5E5E5', '#F2F2F2']
    },
    typography: {
        fontFamilies: [
            {
                fontFamily: 'Roobert',
                src: 'url(../fonts/Roobert/Roobert-Bold.otf)'
            },
            {
                fontFamily: 'Roobert',
                src: 'url(../fonts/Roobert/Roobert-BoldItalic.otf)'
            },
            {
                fontFamily: 'Roobert',
                src: 'url(../fonts/Roobert/Roobert-Heavy.otf)'
            },
            {
                fontFamily: 'Roobert',
                src: 'url(../fonts/Roobert/Roobert-HeavyItalic.otf)'
            },
            {
                fontFamily: 'Roobert',
                src: 'url(../fonts/Roobert/Roobert-Light.otf)'
            },
            {
                fontFamily: 'Roobert',
                src: 'url(../fonts/Roobert/Roobert-LightItalic.otf)'
            },
            {
                fontFamily: 'Roobert',
                src: 'url(../fonts/Roobert/Roobert-Medium.otf)'
            },
            {
                fontFamily: 'Roobert',
                src: 'url(../fonts/Roobert/Roobert-MediumItalic.otf)'
            },
            {
                fontFamily: 'Roobert',
                src: 'url(../fonts/Roobert/Roobert-Regular.otf)'
            },
            {
                fontFamily: 'Roobert',
                src: 'url(../fonts/Roobert/Roobert-RegularItalic.otf)'
            },
            {
                fontFamily: 'Roobert',
                src: 'url(../fonts/Roobert/Roobert-SemiBold.otf)'
            },
            {
                fontFamily: 'Roobert',
                src: 'url(../fonts/Roobert/Roobert-SemiBoldItalic.otf)'
            },
            {
                fontFamily: 'Tusker Grotesk',
                src: 'url(../fonts/TuskerGrotesk/TuskerGrotesk-1500Medium.otf)'
            },
            {
                fontFamily: 'Tusker Grotesk',
                src: 'url(../fonts/TuskerGrotesk/TuskerGrotesk-2500Medium.otf)'
            },
            {
                fontFamily: 'Tusker Grotesk',
                src: 'url(../fonts/TuskerGrotesk/TuskerGrotesk-3500Medium.otf)'
            },
            {
                fontFamily: 'Tusker Grotesk',
                src: 'url(../fonts/TuskerGrotesk/TuskerGrotesk-1600Semibold.otf)'
            },
            {
                fontFamily: 'Tusker Grotesk',
                src: 'url(../fonts/TuskerGrotesk/TuskerGrotesk-2600Semibold.otf)'
            },
            {
                fontFamily: 'Tusker Grotesk',
                src: 'url(../fonts/TuskerGrotesk/TuskerGrotesk-3600Semibold.otf)'
            },
            {
                fontFamily: 'Tusker Grotesk',
                src: 'url(../fonts/TuskerGrotesk/TuskerGrotesk-1700Bold.otf)'
            },
            {
                fontFamily: 'Tusker Grotesk',
                src: 'url(../fonts/TuskerGrotesk/TuskerGrotesk-2700Bold.otf)'
            },
            {
                fontFamily: 'Tusker Grotesk',
                src: 'url(../fonts/TuskerGrotesk/TuskerGrotesk-3700Bold.otf)'
            },
            {
                fontFamily: 'Tusker Grotesk',
                src: 'url(../fonts/TuskerGrotesk/TuskerGrotesk-1800Super.otf)'
            },
            {
                fontFamily: 'Tusker Grotesk',
                src: 'url(../fonts/TuskerGrotesk/TuskerGrotesk-2800Super.otf)'
            },
            {
                fontFamily: 'Tusker Grotesk',
                src: 'url(../fonts/TuskerGrotesk/TuskerGrotesk-3800Super.otf)'
            }
        ],
        lineHeights: [20, 16, 48, 40, 36, 32, 28, 24, 60, 72],
        fontWeights: {
            'roobert-0': 'Bold',
            'tusker-grotesk-1': '7600 Semibold',
            'roobert-2': 'Medium'
        },
        fontSize: [11, 12, 13, 14, 16, 18, 20, 24, 30, 36, 48, 60, 72]
    },
    borderRadius: '73px',
    inputVariant: 'outlined'
};
